import React, { useState, useEffect, useCallback } from 'react'
import { useModal } from 'react-modal-hook'
import TermsConditionService from '../../services/terms-and-conditions.service'
import TermsModal from '../Modal/termsModal'
import envConfig from 'custom/config/environment'
import {SIDENAV_KEYS} from "../../utils/translation-constants"
import { useTranslation } from 'react-i18next';

export default function TermsAndCondition({ module = '', tabIndex='' }) {
  const [dataSource, setDataSource] = useState({})
  const {t}=useTranslation()

  const fetchTermsAndConditions = useCallback(async () => {
    try {
      const response = await TermsConditionService.getTermsAndConditions({
        module: envConfig.TC_MODULE_TYPE === 'CUSTOM' ? module : 'GENERAL',
      })
      if (response.data['termsAndCondition']) {
        setDataSource(response.data['termsAndCondition'][0])
      }
    } catch (err) {}
  }, [])

  useEffect(() => {
    fetchTermsAndConditions()
  }, [])

  const [showModal, hideModal] = useModal(
    () => (
      <TermsModal hideModal={hideModal}>
        <div className='modal-error-body'>
          <div>
            <p
              dangerouslySetInnerHTML={{ __html: dataSource?.message || '' }}
              className='text-justify'
              style={{ height: 300, padding: 20, overflow: 'overlay',whiteSpace:'pre-line' }}></p>
          </div>
        </div>
      </TermsModal>
    ),
    [dataSource],
  )

  return (
    <div>
      <label
        className='form-check-label control-label'
        style={{ textAlign: 'center', width: '250px', margin: '0 auto', display: ' block' }}
        htmlFor='tnc'>
          {t(SIDENAV_KEYS.TERMS_AND_CONDITIONS_KEYS.CONFIRM_TERMS_CONDITION)}
        <button
          className='btn btn-sm p-0 font-weight-500'
          tabIndex={tabIndex}
          onClick={() => showModal()}
          style={{ color: 'blue', cursor: 'pointer', fontSize:'11px', marginLeft:'5px' }}
          type='button'
          data-toggle='modal'
          data-target='.bd-example-modal-lg'>
          {t(SIDENAV_KEYS.TERMS_AND_CONDITIONS_KEYS.TITLE)}
        </button>
      </label>
    </div>
  )
}
